<template xmlns="http://www.w3.org/1999/html">
  <!-- 神通 -->
  <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" style="font-family: Arial,Helvetica,Sans-Serif;">
    <p slot="title">神通符箓</p>
    <div slot="extra"></div>
    <h4>神通</h4>
    <div class="parent" >
      <div  :style="{
                      border: '2px solid '+color,
                      width: ' 99.5%',
                      height: '75px','line-height': '75px','text-align': 'center',
                    }"  class="div1" ><span v-if="activeList.length<=0">无</span></div>
<!--      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div2"></div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div3"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div4"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div5"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div6"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div7"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div8"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div9"> 无</div>
      <div  style=" border: 1px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center" class="div10"> 无</div>-->
      <div  :style="{
                      border: '2px solid '+color,
                      width: ' 99.5%',
                      height: '75px',color : '#707070','text-align': 'center',
                    }"  :class="'div'+(index+1)" v-for="(item, index) in activeList" :key="index">
        <Poptip
          trigger="click"
          :title="item.skillName"
          width="400"
          word-wrap
        >
          <p >
            <icon></icon>
            <span style="color: #8b78e6"> 『{{ distinguishColor(item.skillOrder)  }}』</span>
            <span style="display: flex;align-items: center">{{ item.skillName }}</span>
          </p>
          <div slot="content">
            <p>神通效果: {{ item.skillDesc }}</p>
            <p>神通冷却: <label>{{ item.cooling }}</label></p>
            <Button
              @click.prevent="TakeSkill(item)"
              size="small"
              type="info" ghost
            >
              卸下
            </Button>
          </div>
        </Poptip>
      </div>
    </div>
    <h4>符箓</h4>
<!--    <div class="parent1">
      <div  style=" border: 2px solid #abb6c0;width: 75px;height: 75px;line-height: 75px;text-align: center;" class="ddiv1" ><span v-if="passiveList.length<=0">无</span></div>
    </div>-->
    <div class="parent2">
      <div  :style="{
                      border: '2px solid '+color,
                      width: ' 99.5%',
                      height: '75px','line-height': '75px','text-align': 'center',
                    }"   :class="'ddiv'+(index+1)" v-for="(item, index) in passiveList" :key="index">
        <Poptip
          trigger="click"
          :title="item.skillName"
          width="400"
          word-wrap
        >
          <p >
            <span style="display: flex;align-items: center">
              {{ item.skillName }}</span>
          </p>
          <div slot="content">
            <p>符箓效果: {{ item.skillDesc }}</p>
            <Button
              @click.prevent="TakeSkill(item)"
              size="small"
              type="info" ghost
            >
              卸下
            </Button>
          </div>
        </Poptip>
        <!--        <span style="padding: 0px 10px" :style="{ color: distinguishColor(item.color) }" >{{ item.busName }}</span><br>
                <span style="padding: 0px 10px;color:#1890ff ">数量：{{ item.goodNum }}</span><br>
                <span style="padding: 0px 10px">卖家：{{ item.sellerName }}</span><br>
                <span style="color:#ff8c00;height: 30px;line-height:30px;padding: 0px 10px"><Icon type="ios-pricetags-outline" /> {{ item.price }}</span>
                <Button @click.prevent="purchase(item)" size="small" >
                  购买
                </Button>-->
      </div>
    </div>
    <div style="margin-top: 16px">
      <h4>神通符箓</h4>
<!--      <div style="overflow: hidden; margin-bottom: 15px">
        <div class="activeSkill">
          <h4>主动神通</h4>
          <div  class="skillList"
            v-for="(item, index) in activeList"
            :key="index"
            style="margin-bottom: 4px"
          >
            &lt;!&ndash; <span>{{ item.skillName }}:</span> &ndash;&gt;
            <Poptip
              trigger="hover"
              :title="item.skillName"
              width="400"
              word-wrap
            >
              <p style="white-space: nowrap; height: 24px">
                <span>{{ item.skillName }}</span>
                <Button
                  @click.prevent="TakeSkill(item, 1)"
                  size="small"
                  type="info" ghost
                >
                  卸下
                </Button>
              </p>
              <div slot="content">
                <p>神通效果: {{ item.skillDesc }}</p>
                <p>神通耗蓝: {{ item.conMana }}</p>
                <p>升级所需灵石 {{ item.consumeCoin }}</p>
                <p>升级人物等级 {{ item.charaLevel }}</p>
                <p>下一等级神通效果: {{ item.skillNextDesc }}</p>
              </div>
            </Poptip>
          </div>
        </div>
        <div class="passiveSkill">
          <h4>被动神通</h4>
          <div  class="skillList"
            v-for="(item, index) in passiveList"
            :key="index"
            style="margin-bottom: 4px"
          >
            <Poptip
              width="400"
              word-wrap
              trigger="hover"
              :title="item.skillName"
            >
              <p style="white-space: nowrap; height: 24px">
                <span>{{ item.skillName }}</span>
                <Button
                  @click.prevent="TakeSkill(item, 2)"
                  size="small"
                  type="info" ghost
                >
                  脱下
                </Button>
              </p>
              <div slot="content">
                <p>神通效果: {{ item.skillDesc }}</p>
              </div>
            </Poptip>
          </div>
        </div>
      </div>-->
      <div class="skillList">
        <Poptip
          width="400"
          word-wrap
          trigger="hover"
          v-for="item in skillList"
          :key="item.skillId"
          :title="item.skillName"
        >
          <p
            style="white-space: nowrap; height: 24px;margin: 3px 0"
            :style="{ color: item.color }"
          > <span> <Tag color="default" size="24" v-if="!isActive">[{{  baibaoReturnType(item.skillType)  }}]</Tag>
           <span style="color: #51629f" v-if="isActive">[{{  baibaoReturnType(item.skillType)  }}]</span></span>
            {{ item.skillName }}
            <Button @click.prevent="jineng(item)" size="small" type="info" ghost>
              装备
            </Button>
            <Button @click.prevent="upgrade(item)" size="small" type="info" >
              升级
            </Button>
          </p>
          <div slot="content">
            <!-- <p>{{ item.skillName }}</p> -->
            <p style="color: #00adff">神通效果: {{ item.skillDesc }}</p>
            <p style="color: #2d8cf0">神通冷却: <label >{{ item.cooling }}</label></p>
            <div v-if="item.charaLevel !== null">
              <p style="color: #de5431">升级所需灵石: <label  style="color: #de5431">{{ item.consumeCoin }}</label></p>
              <p v-if="item.skillType ===0 || item.skillType ===1"  style="color: #de5431">升级所需碎片: {{ item.consumeMatNum }}</p>
              <p style="color: #de5431">升级人物等级: <label  >{{ item.charaLevel }}</label></p>
            </div>
            <div v-if="item.charaLevel=== null">
              <p>不可升级</p>
            </div>
            <p style="color: #426666">下一等级神通效果: {{ item.skillNextDesc }}</p>
          </div>
        </Poptip>
      </div>
    </div>
    <Modal v-model="jinengEject" title="技能栏位置" @on-ok="skillEquip()">
      <p>技能栏位置(1-10)</p>
      <div >
        <Select v-model="jinengWz" placeholder="技能栏位置" default-label="1">
          <Option value="1" label="1">
            <span>1号位</span>
          </Option>
          <Option value="2" label="2">
            <span>2号位</span>
          </Option>
          <Option value="3" label="3">
            <span>3号位</span>
          </Option>
          <Option value="4" label="4">
            <span>4号位</span>
          </Option>
          <Option value="5" label="5">
            <span>5号位</span>
          </Option>
          <Option value="6" label="6">
            <span>6号位</span>
          </Option>
          <Option value="7" label="7">
            <span>7号位</span>
          </Option>
          <Option value="8" label="8">
            <span>8号位</span>
          </Option>
          <Option value="9" label="9">
            <span>9号位</span>
          </Option>
          <Option value="10" label="10">
            <span>10号位</span>
          </Option>
        </Select>
      </div>
    </Modal>
  </Card>
</template>

<script>
export default {
  name: "skill",
  data() {
    return {
      activeList: [], // 穿戴的主动神通列表
      passiveList: [], // 穿戴的被动神通列表
      skillList: [], // 全部神通
      jinengEject: false,
      jinengWz: 1,
      color: '#abb6c0',
      isActive:false, // 切换主体
      eSkill: null,
    };
  },
  created() {
    this.getAllSkill();
    this.getEquipmentSkill();
    const theme = window.localStorage.getItem("isTheme");
    if(theme === "black"){
      this.isActive=true;
      this.color= '#373e57';
    }else{
      this.isActive=false;
      this.color='#abb6c0';
    }
  },
  mounted() {
    this.$bus.$on("getSkillMsg", () => {
      this.getAllSkill();
    });
  },
  methods: {
    // 脱下神通
    TakeSkill(item) {
      this.$http
        .post(
          "gameCharaSkill/makeDownSkill/?charaId=" +
            this.getCookie("charaId") +
            "&skillId=" +
            item.skillId +
            "&skillType=" +
            item.skillType
        )
        .then((res) => {
          this.$Notice.warning({title:"神通脱下成功"});

          this.$bus.$emit("skillMsg", "脱下神通发送过来的");
          this.getAllSkill();
          this.getEquipmentSkill();
        })
        .catch((err) => {
          this.$Notice.warning({title:"神通脱下失败,请联系管理员"});
        });
    },
    distinguishColor(color) {
      if (color == 1) {
        return "壹";
      } else if (color == 2) {
        return "贰";
      } else if (color == 3) {
        return "叁";
      } else if (color == 4) {
        return "肆";
      } else if (color == 5) {
        return "伍";
      } else if (color == 6) {
        return "陆";
      } else if (color == 7) {
        return "柒";
      } else if (color == 8) {
        return "捌";
      } else if (color == 9) {
        return "玖";
      } else {
        return "拾";
      }
    },
    // 返回技能分类
    baibaoReturnType(type) {
      if (type == 0) {
        return "道法";
      } else if (type == 1) {
        return "真气";
      } else if (type == 2) {
        return "天赋";
      } else {
        return "其他";
      }
    },
    // 获取角色的神通列表
    getAllSkill() {
      this.$http
        .post(
          "gameCharaSkill/getCharaSkill/?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          this.skillList = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({title:err.data.msg});
        });
    },

    // 获取角色已装备的神通列表
    getEquipmentSkill() {
      this.$http
        .post(
          "gameCharaSkill/getCharaUseSkill/?charaId=" +
            this.getCookie("charaId") +
            "&skillType=" +
            1
        )
        .then((res) => {
          this.activeList = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({title:err.data.msg});
        });

      this.$http
        .post(
          "gameCharaSkill/getCharaUseSkill/?charaId=" +
            this.getCookie("charaId") +
            "&skillType=" +
            2
        )
        .then((res) => {
          this.passiveList = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({title:"获取已装备的被动神通列表失败,请联系管理员"});
        });
    },
    jineng(item){
      this.eSkill=item;
      if(this.eSkill.skillType !== 2){
        this.jinengEject=true;
      }else{
        this.skillEquip();
      }
    },
    // 装备神通
    skillEquip() {
      this.$http
        .post(
          "gameCharaSkill/makeSkill/?charaId=" +
            this.getCookie("charaId") +
            "&skillId=" +
            this.eSkill.skillId +
            "&skillType=" +
            this.eSkill.skillType +
            "&skillOrder=" +
            this.jinengWz
        )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});
          this.$bus.$emit("skillMsg1", "装备神通发送过来的");
          this.getAllSkill();
          this.getEquipmentSkill();
        })
        .catch((err) => {
          this.$Notice.warning({title:err.data.msg});
          this.getAllSkill();
        });
    },

    // 神通升级
    upgrade(item) {
      this.$http
        .post(
          "/gameCharaSkill/upgradeSkill?charaId=" +
            this.getCookie("charaId") +
            "&skillId=" +
            item.skillId
        )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});
          this.getAllSkill();
        })
        .catch((err) => {
          this.$Notice.warning({title:"神通升级失败,请联系管理员"});
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 神通栏 */
.activeSkill {
  float: left;
  width: 50%;
  text-align: center;
}
.passiveSkill {
  float: right;
  width: 50%;
  text-align: center;
}
* {
  font-family: '思源黑体', sans-serif ;
}
label {
  content: attr(data-numbers);
  font-family: 'Roboto', sans-serif !important; /* 为数字设置字体 */
}
/* 神通列表 */
.skillList /deep/ .ivu-poptip-popper {
  pointer-events: none;
}
.skillList /deep/ .ivu-poptip {
  width: 50%;
}
.skillList /deep/ .ivu-poptip p button {
  display: none;
  height: 22px;
}
.skillList /deep/ .ivu-poptip p:hover {
  z-index: 9;
  position: relative;
}
.skillList /deep/ .ivu-poptip p:hover button {
  display: inline-block;
}
.parent {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.div1 { grid-area: 1 / 1 / 2 / 2; }
.div2 { grid-area: 1 / 2 / 2 / 3; }
.div3 { grid-area: 1 / 3 / 2 / 4; }
.div4 { grid-area: 1 / 4 / 2 / 5; }
.div5 { grid-area: 1 / 5 / 2 / 6; }
.div6 { grid-area: 2 / 1 / 3 / 2; }
.div7 { grid-area: 2 / 2 / 3 / 3; }
.div8 { grid-area: 2 / 3 / 3 / 4; }
.div9 { grid-area: 2 / 4 / 3 / 5; }
.div10 { grid-area: 2 / 5 / 3 / 6; }

.parent2 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.parent2child{

}
.parent2child2{

}
.ddiv1 { grid-area: 1 / 1 / 2 / 2; }
.ddiv2 { grid-area: 1 / 2 / 2 / 3; }
.ddiv3 { grid-area: 1 / 3 / 2 / 4; }
.ddiv4 { grid-area: 1 / 4 / 2 / 5; }
.ddiv5 { grid-area: 1 / 5 / 2 / 6; }
.ddiv6 { grid-area: 2 / 1 / 3 / 2; }
.ddiv7 { grid-area: 2 / 2 / 3 / 3; }
.ddiv8 { grid-area: 2 / 3 / 3 / 4; }
.ddiv9 { grid-area: 2 / 4 / 3 / 5; }
.ddiv10 { grid-area: 2 / 5 / 3 / 6; }
.blackBackGroup{
  background-color: #151728;
  border: none;
  color: #9c9cab;
}
.blackBackGroup .ivu-card-head p, .ivu-card-head-inner{
  color: #4975d4;
}
.blackBackGroup span{
  background-color: #151728;
  color: #9c9cab;
}
.blackBackGroup2{

}
</style>



// WEBPACK FOOTER //
// src/components/skill.vue